import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'member/personal/orders', // 资源路径
    defaultRels: ['orderProducts', 'activity', 'orderInvoices'], // 默认需要的关联数据
    defaultQuery: {} // 默认的通用查询
  }

})
